import { carePlanApi } from "./care-plan";

export const carePlanQueryKeys = {
  all: ["patient", "care-plans"] as const,
  listForPatient: (patientId: string) =>
    [...carePlanQueryKeys.all, "list", patientId] as const,
  detail: (id: string) => [...carePlanQueryKeys.all, "detail", id] as const,
  logs: (carePlanId: string) =>
    [...carePlanQueryKeys.all, "logs", carePlanId] as const,
};

export const carePlanQueryOptions = {
  listForPatient: (patientId?: string) => ({
    queryKey: carePlanQueryKeys.listForPatient(patientId ?? ""),
    queryFn: () => carePlanApi.list(patientId ?? ""),
    enabled: !!patientId,
  }),
  detail: (id?: string) => ({
    queryKey: carePlanQueryKeys.detail(id ?? ""),
    queryFn: () => carePlanApi.get(id ?? ""),
    enabled: !!id,
  }),
  logs: (carePlanId?: string) => ({
    queryKey: carePlanQueryKeys.logs(carePlanId ?? ""),
    queryFn: () => carePlanApi.getLogs(carePlanId ?? ""),
    enabled: !!carePlanId,
  }),
};
